module.exports = __webpack_public_path__ + "c7e668c4a08be6eeb83e0d62a9c44394.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Sand_Big_RGB.png
// module id = 186
// module chunks = 0